import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const Facebook = ({ size, color, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '40px'}
      height={size || '40px'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 40 40"
      fill={color || 'currentColor'}
    >
      <path
        d="M3.121,19.989c0.002,8.354,6.04,15.468,14.24,16.777V24.897h-4.282v-4.908h4.287v-3.736
        c-0.192-1.77,0.409-3.535,1.64-4.815c1.231-1.28,2.963-1.943,4.728-1.809c1.267,0.021,2.53,0.134,3.781,0.34v4.176h-2.134
        c-0.734-0.097-1.473,0.147-2.007,0.663c-0.534,0.516-0.807,1.249-0.741,1.991v3.189h4.677l-0.748,4.91h-3.929v11.867
        c8.868-1.41,15.088-9.56,14.151-18.545C35.849,9.236,28.086,2.561,19.12,3.032C10.153,3.503,3.123,10.955,3.121,19.989z"
        fill={color || 'currentColor'}
      />
    </StyledSvg>
  );
};
